import React, { useState } from 'react';
import './NavigationMobile.styles.css';
import { Links, LinksVariants } from '../../UI/Links/Links';
import { logoutUser } from '../../utils/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icons, IconsVariants } from '../../UI';

export const NavigationMobile: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const userIsLogged = !!userId;

  // Function to toggle menu visibility
  const toggleMenu = () => {
    setMenuOpen(curr => !curr);
  };

  const onLogout = () => {
    logoutUser();
    toggleMenu();
    navigate('/');
  };

  return (
    <div className="navigation-mobile laptop:hidden">
      {/* Button to toggle menu visibility */}
      <button className="menu-toggle-btn text-app-2xl" onClick={toggleMenu}>
        <Icons variant={IconsVariants.HAMBURGER_2} />
      </button>

      {/* Mobile navigation menu */}
      <nav className={`px-app-base mobile-navigation ${menuOpen ? 'menu-open' : 'menu-closed'}`}>
        <div className='flex justify-end'>
          <button className="text-app-2xl p-app-base" onClick={toggleMenu}>
            <Icons variant={IconsVariants.X} />
          </button>
        </div>
        <ul className='flex-1'>
          <li>
            <Links
              onClick={toggleMenu}
              variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
              iconVariant={IconsVariants.HOME_FULL}
              to={`/`}
              text='Home'
            />
          </li>
          <li>
            <Links
              onClick={toggleMenu}
              variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
              iconVariant={IconsVariants.INFO}
              to={`/about`}
              text='What is Pinion?'
            />
          </li>
          {userIsLogged && (
            <li>
              <Links
                onClick={toggleMenu}
                variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                iconVariant={IconsVariants.LAYER}
                to={`/user-questions/${userId}`}
                text='My pinions'
              />
            </li>
          )}
          {userIsLogged ? (
            <>
              <li>
                <Links
                  onClick={toggleMenu}
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.PLUS_SQUARE}
                  to={`/create-pinion`}
                  state={{ backgroundLocation: location }}
                  text='New pinion'
                />
              </li>
              <li>
                <Links
                  onClick={toggleMenu}
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.BOOKMARK_FULL}
                  to={`/bookmarks`}
                  text='Bookmarks'
                />
              </li>
              <li>
                <Links
                  onClick={toggleMenu}
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.HEART_FULL}
                  to={`/soulmates`}
                  text='Soulmates'
                />
              </li>
              <li>
                <Links
                  onClick={toggleMenu}
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.BELL_FULL}
                  to={`/notifications`}
                  text='Notifications'
                />
              </li>
              <li>
                <Links
                  onClick={toggleMenu}
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.PROFILE_FULL}
                  to={`/profile/${userId}`}
                  text='Profile'
                />
              </li>
              <li>
                <Links
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.POWER_OFF}
                  text='Logout'
                  to={'/logout'}
                  onClick={onLogout}
                  preventNavigation={true}
                />
              </li>
            </>
          ) : (
            <>
              <li>
                <Links
                  onClick={toggleMenu}
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.USER_FULL}
                  text='Login'
                  to={'/login'}
                  state={{ backgroundLocation: location }}
                />
              </li>
              <li>
                <Links
                  onClick={toggleMenu}
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.ID_CARD}
                  text='Register'
                  to={'/register'}
                  state={{ backgroundLocation: location }}
                />
              </li>
            </>
          )}
        </ul>
      </nav>
    </div>
  );
};
